"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.Main = void 0;
var logging_handler_1 = require("./handlers/logging.handler");
var logging_lookup_1 = require("./lookups/logging.lookup");
Object.defineProperty(exports, "LoggingType", { enumerable: true, get: function () { return logging_lookup_1.LoggingTypeLookUp; } });
var severity_lookup_1 = require("./lookups/severity.lookup");
Object.defineProperty(exports, "SeverityType", { enumerable: true, get: function () { return severity_lookup_1.SeverityTypeLookUp; } });
var Main = /** @class */ (function () {
    function Main() {
        this.logging = new logging_handler_1.LoggingHandler();
    }
    return Main;
}());
exports.Main = Main;
exports.Logger = new Main().logging;
//# sourceMappingURL=index.js.map